import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SearchService {
    private searchingSubject = new Subject<string>();
    private resetSearchSubject = new Subject<void>();

    get searchEvent$(): Subject<string> {
        return this.searchingSubject;
    }

    get resetSearchEvent$(): Subject<void> {
        return this.resetSearchSubject;
    }

    public emitSearchEvent(input: string): void {
        this.searchingSubject.next(input);
    }

    public resetSearch(): void {
        this.resetSearchSubject.next();
    }

    public getSearchPattern(input: string): RegExp {
        const escapedInput = this.getEscapedInput(input);

        return new RegExp(escapedInput, 'gi');
    }

    private getEscapedInput(input: string): string {
        const escapePattern = /[.*+?^<>${}()|[\]\\/]/gi;

        return input.trim().replace(escapePattern, '\\$&');
    }
}
